import { Car } from "lucide-react";
import React from "react";
import { cn } from "@/lib/utils";
import { useTranslation } from "react-i18next";
import CombustionIcon from "../icons/CombustionIcon";
import RechargesIcon from "../icons/RechargesIcon";
import ElectricityIcon from "../icons/ElectricityIcon";
import VehicleIcon from "../icons/VehicleIcon";

interface DashboardScopeCardProps {
  scope: number;
  value: number;
  icon?: React.ReactNode;
  bg?: string;
  categories: string[];
}

export const DashboardScopeCard = ({
  scope,
  value,
  icon,
  bg,
  categories,
}: DashboardScopeCardProps) => {
  const t = useTranslation().t;
  const defaultIcon = React.createElement(Car, { size: 48 });

  return (
    <div className="flex items-center">
      {/* Content */}
      <div className="flex items-center justify-between w-full">
        <div className="flex items-center gap-2 relative">
          {/* Green vertical bar */}
          <div className={cn("w-4 h-4 rounded-full", bg)}></div>

          {/* Scope */}
          <div className="flex items-center gap-4">
            <span className="text-[14px] font-semibold text-gray-900">
              {t("common.level")} {scope}
            </span>
          </div>

          <div className="flex space-x-2">
            {categories.includes("combustion") && (
              <CombustionIcon height={24} width={24} />
            )}
            {categories.includes("consumption") && (
              <VehicleIcon height={24} width={24} />
            )}
            {categories.includes("recharges") && (
              <RechargesIcon height={24} width={24} />
            )}
            {categories.includes("electricity") && (
              <ElectricityIcon height={24} width={24} />
            )}
          </div>
        </div>

        {/* Value */}
        <div className="flex items-baseline space-x-4 text-right">
          <div className="text-[20px] font-extrabold text-gray-900">
            {(value / 1000).toFixed(2)}
          </div>
          <div className="text-[12px] font-extrabold">ton. CO2 eq.</div>
        </div>
      </div>
    </div>
  );
};
